// extracted by mini-css-extract-plugin
export var bg = "pages-module--bg--RMDEt";
export var bgMask = "pages-module--bgMask--uAAlI";
export var bgAnimationContainer = "pages-module--bgAnimationContainer--qgBqB";
export var bgAnimationInner = "pages-module--bgAnimationInner--86UHh";
export var bgAnimation = "pages-module--bgAnimation--A20WC";
export var bgPage = "pages-module--bgPage--bZPmQ";
export var fullscreen = "pages-module--fullscreen--Yv2EZ";
export var pagesContainer = "pages-module--pagesContainer--kulnd";
export var pagesFrame = "pages-module--pagesFrame--u6UrR";